import React, { memo } from "react";
import { Box } from "app/components/common";
import { ResponsiveValue } from "@shopify/restyle";
import { Theme } from "app/Theme/Theme";

interface Props {
  width: number;
  color: ResponsiveValue<keyof Theme["colors"], Theme>;
  height?: number;
}

const Step = ({ color, width, height = 4 }: Props) => {
  return (
    <Box
      width={width}
      height={height}
      borderRadius={100}
      backgroundColor={color}
    />
  );
};

export default memo(Step);
